export default __webpack_public_path__ + "static/media/expand-more.2f05adbe.svg";